import React, { useState, useEffect } from 'react';
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import './InputDate.css';
import { forwardRef } from 'react';
import DateRangeCustom from "/src/features/supervision/conversations/components/ConversationFilter/DateRangeCustom/DateRangeCustom";
import calendarSVG from '/src/assets/img/svg/calendar.svg';
//import "./InputSvg.css"
const InputDate = forwardRef(({ className, dates, setValue, width, removeSeparator }, ref) => {
    const onClickView = () => {
        NiceModal.show(DateRangeCustom, {
            onDateRangeSelection: handleDateRangeSelection
        })
    }
    const formatDate = (_dates) => {
        return { startDate: _dates.split(",")[0], endDate: _dates.split(",")[1] }
    }
    const [selectedDates, setSelectedDates] = useState(dates ? formatDate(dates) : null);
    const handleDateRangeSelection = (startDate, endDate) => {
        setSelectedDates({ startDate, endDate });
        if (setValue != null) {
            setValue(`${startDate},${endDate}`)

        }
    };

    useEffect( ()=>{
        setSelectedDates(dates ? formatDate(dates) : null)
    },[dates])
    return (
        <div className={"input-date-container " + (className ? className : '')} style={{ width: width + 'px' }} onClick={onClickView}>
            <img srcSet={calendarSVG} width={20} height={20} style={{ marginLeft: "20px" }} />
            <div className="text_result_date">
                {selectedDates ?
                    <span> {selectedDates.startDate} {removeSeparator != true && <span style={{ color: 'var(--main)', fontSize: "20px" }}>·</span>} {selectedDates.endDate}</span>
                    :
                    "Choose date"
                }
            </div>
        </div>


    )
})
InputDate.defaultProps = {
    name: "",
    className: "",
}

export default InputDate